import React, { useEffect } from 'react'

import {useImmer} from 'use-immer'
import Axios from 'axios'
import Loader from '../Loader/Loader'
import PostListTemplate from './templates/PostListTemplate'
import Posts from './Posts'

import './SearchTemplate.css'

function SearchTemplate({searchUrl, searchPlaceholder, searchType}) {

    const [state, setState] = useImmer({
        searchTerm: "",
        results: [],
        requestCount: 0,
        isLoading: false
        
    })

    useEffect(() => {

        const delay = setTimeout(() => {
            setState(draft => {
                draft.requestCount++
            })
        }, 500)

        return () => clearTimeout(delay)

    }, [state.searchTerm])

    useEffect(() => {

        if (state.requestCount) {
            const ourRequest = Axios.CancelToken.source();

            async function fetchResults() {

                setState((draft) => {
                    draft.isLoading = true;
                })

                try {
                    const response = await Axios.get(searchUrl + state.searchTerm, );

                    setState((draft) => {
                        draft.results = response.data
                    })

                } catch (error) {
                    
                }

                setState((draft) => {
                    draft.isLoading = false;
                })

            }
            fetchResults();

            return () => ourRequest.cancel();

        }

    }, [state.requestCount])

    function handleInput(e) {
        const value = e.target.value
        setState((draft) => {
            draft.searchTerm = value
        })
    }

    return (
        <div>
            <div className="search-overlay-top shadow-sm">
                <div className="container container--narrow">
                    <label htmlFor="live-search-field" className="search-overlay-icon">
                    <i className="fas fa-search"></i>
                    </label>
                    <input onChange={handleInput} autoFocus type="text" autoComplete="off" id="live-search-field" className="live-search-field" placeholder={searchPlaceholder} />
                </div>
            </div>

            <div className="container">
                {state.isLoading && state.searchTerm && <Loader/> } 
                <div className="row">
                    {state.results?.map(post => {
                        return <PostListTemplate key={post?.id} post={post} />
                    })}
                </div>
              
                {state.results?.length < 1 && state.searchTerm && (
                    <React.Fragment>
                        <p>Ingen resultater for dette søket</p>
                        <h2>All posts</h2>
                        <hr />
                        <Posts />
                    </React.Fragment>
                )}
               
            </div>

        </div>
    )

}
export default SearchTemplate